.navbarButton {
  && {
    border-radius: var(--mantine-radius-sm);
    font-size: var(--mantine-font-size-sm);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    transition:
      background-color 0.2s ease,
      color 0.2s ease;
    color: var(--mantine-color-text) !important;
    font-weight: 500;
    display: flex;
    align-items: center;

    &[data-active] {
      background-color: light-dark(
        var(--mantine-color-gray-light-hover),
        var(--mantine-color-gray-6)
      );
    }

    &:hover {
      background-color: light-dark(
        var(--mantine-color-gray-light-hover),
        var(--mantine-color-gray-5)
      );
    }
  }
}
